export default __webpack_public_path__ + "static/media/protest.70cd11de.png";